import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'awRound',
})
export class RoundPipe implements PipeTransform {
  transform(value: number): number {
    return Math.round(value);
  }
}
